export default __webpack_public_path__ + "static/media/speakers__guilherme-rambo.c2405a2d.jpg";